<template>
  <div class="row">
    <div class="col-md-4 form-group">
      <label>{{ $t('involvedForm.object.type.label') }}</label>
      <select
        v-model="value.object_type"
        class="form-control"
        :disabled="disabled"
      >
        <option value="">
          {{ $t('involvedForm.object.type.selectPlaceholder') }}
        </option>
        <option value="arma">
          {{ $t('involvedForm.object.type.options.weapon') }}
        </option>
        <option value="eletronico">
          {{ $t('involvedForm.object.type.options.electronic') }}
        </option>
        <option value="documento">
          {{ $t('involvedForm.object.type.options.document') }}
        </option>
        <option value="joia">
          {{ $t('involvedForm.object.type.options.jewelry') }}
        </option>
        <option value="outro">
          {{ $t('involvedForm.object.type.options.other') }}
        </option>
      </select>
    </div>
    <div class="col-md-8 form-group">
      <label><span class="text-danger">*</span> {{ $t('involvedForm.object.description.label') }}</label>
      <input
        v-model="value.description"
        type="text"
        class="form-control"
        :class="{ 'is-invalid': errors.description }"
        :disabled="disabled"
        :placeholder="$t('involvedForm.object.description.placeholder')"
      >
      <div
        v-if="errors.description"
        class="invalid-feedback"
      >
        {{ $t('involvedForm.object.description.requiredError') }}
      </div>
    </div>

    <div class="col-md-5 form-group">
      <label>{{ $t('involvedForm.object.brand.label') }}</label>
      <input
        v-model="value.brand"
        type="text"
        class="form-control"
        :disabled="disabled"
      >
    </div>
    <div class="col-md-4 form-group">
      <label>{{ $t('involvedForm.object.model.label') }}</label>
      <input
        v-model="value.model"
        type="text"
        class="form-control"
        :disabled="disabled"
      >
    </div>
    <div class="col-md-3 form-group">
      <label>{{ $t('involvedForm.object.quantity.label') }}</label>
      <input
        v-model.number="value.quantity"
        type="number"
        min="1"
        class="form-control"
        :disabled="disabled"
      >
    </div>

    <div class="col-md-6 form-group">
      <label>{{ $t('involvedForm.object.serialNumber.label') }}</label>
      <input
        v-model="value.serial_number"
        type="text"
        class="form-control"
        :disabled="disabled"
      >
    </div>
    <div class="col-md-6 form-group">
      <label>{{ $t('involvedForm.object.estimatedValue.label') }}</label>
      <input
        v-model.number="value.estimated_value"
        type="number"
        step="0.01"
        min="0"
        class="form-control"
        :disabled="disabled"
      >
    </div>

    <div class="col-12 form-group">
      <label>{{ $t('involvedForm.object.observation.label') }}</label>
      <textarea
        v-model="value.observation"
        class="form-control"
        rows="2"
        :disabled="disabled"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'InvolvedObjectForm',
  props: {
    value: { type: Object, required: true },
    errors: { type: Object, default: () => ({}) },
    disabled: { type: Boolean, default: false },
  },
}
</script>
